
import { defineComponent, PropType } from 'vue'

import ActiveUserMixin from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'

import { resolveNodes } from '~/utils/array'
import { getDefaultAvatar } from '~/utils/ui'

import superuserList from '~/apollo/queries/enterprise/superuserList.gql'

import { GraphqlQueryResponse } from '~/types/apollo-graphql-types'
import { RequestAccessErrorVariant } from '~/types/errorTypes'
import { EnterpriseUser } from '~/types/types'

export default defineComponent({
  name: 'RequestAccess',
  mixins: [ActiveUserMixin, AuthMixin],
  props: {
    copytext: {
      type: String,
      default: ''
    },
    variant: {
      type: String as PropType<RequestAccessErrorVariant>,
      default: 'request-access'
    }
  },
  data() {
    return {
      superuserList: [] as Array<EnterpriseUser>,
      loading: false,
      totalSuperuserCount: 0,
      installationLogo: ''
    }
  },
  methods: {
    getDefaultAvatar
  },
  async fetch() {
    this.loading = true

    if (!this.viewer.id) {
      await this.fetchActiveUser({ refetch: true })
    }

    try {
      const response = (await this.$fetchGraphqlData(superuserList, {})) as GraphqlQueryResponse

      this.superuserList = resolveNodes(response.data.enterprise?.superusers)
      this.totalSuperuserCount = response.data.enterprise?.superusers?.totalCount ?? 0
      this.installationLogo = response.data.enterprise?.installation?.logo ?? ''
    } catch (e) {
      this.$logErrorAndToast(
        e as Error,
        'Unable to fetch details for the installation. Please contact support.'
      )
    } finally {
      this.loading = false
    }
  },
  computed: {
    logoutMenuProps() {
      const { avatar, email, fullName } = this.viewer
      return {
        avatar,
        email,
        fullName
      }
    },
    title() {
      return this.variant === 'insufficient-permissions'
        ? 'Insufficient Permissions'
        : 'Request access'
    }
  }
})
